import { render } from "./RevisionTypeSelector.vue?vue&type=template&id=3ec1297d"
import script from "./RevisionTypeSelector.vue?vue&type=script&lang=js"
export * from "./RevisionTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__